import { Injectable } from '@angular/core';
import { Adapter } from '../interfaces/adapter.interface';
import { HelperService } from '../services/shared/helper/helper.service';

export class Rule {
  constructor(
    public id: number = 0,
    public name: string = '',
    public query: string = '',
    public createdOn: Date = new Date(),
    public modifiedOn: Date = new Date(),
    public equations: any[] = [],
    public actions: any[] = []
  ){}
}

@Injectable({
    providedIn: 'root'
})

export class RuleAdapter implements Adapter<Rule> {

  constructor(private _helper: HelperService){}

  adapt(item: any): Rule {
    return new Rule(
      item.id,
      item.name,
      item.query,
      (item.created_on) ? new Date(item.created_on) : null,
      (item.updated_on) ? new Date(item.updated_on) : null,
      (item.equation) ? item.equation : [],
      (item.action) ? item.action : []
    );
  }

  reverseAdapt(item: any): any {
    return {
      id: item.id,
      name: item.name,
      created_by: this._helper.user.get()['id'],
      updated_by: this._helper.user.get()['id'],
      action: item.actions,
      equation: item.equations,
      query: item.query
    }
  }

}